import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import SEOHead from "@/components/SEOHead";
import { BOOKING_15MIN_URL } from "@/hooks/use-cal";

const Reservation15Minutes = () => (
  <main className="min-h-dvh bg-background text-foreground">
    <SEOHead
      title="Réserver un appel de 15 minutes"
      description="Choisis une date et une heure pour discuter avec l'équipe de l'Agence 8020."
      canonical="https://agence8020.com/reservation-15-minutes"
      noIndex
    />

    <header className="flex h-14 shrink-0 items-center border-b border-border bg-background px-4 md:px-6">
      <Link
        to="/plan-de-match"
        className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        Retour au Plan de match
      </Link>
    </header>

    <div className="mx-auto h-[714px] w-full max-w-5xl overflow-hidden bg-background md:h-[702px]">
      <iframe
        src={BOOKING_15MIN_URL}
        title="Réserver un appel de 15 minutes"
        className="block h-[714px] w-full border-0 bg-background md:-mt-16 md:h-[814px]"
        allow="payment"
        scrolling="yes"
        loading="eager"
      />
    </div>
  </main>
);

export default Reservation15Minutes;